import { BrandedSplitLayout } from "../../../branding/components/BrandedSplitLayout";
import { BrandedResultMessage } from "../../../branding/components/BrandedResultMessage";
import { routesConfig } from "../../../config/routes";
import { useContextualNavigate } from "../../../hooks/ContextualNavigations";

// Paridade da rota /confirm-email sob a marca. Acesso direto não tem e-mail (sem
// location.state nem query), então a copy é a original da Atem, sem {email}.
export const ForgotPasswordLastStepBranded = (): JSX.Element => {
  const navigate = useContextualNavigate();

  return (
    <BrandedSplitLayout>
      <BrandedResultMessage
        title="Confira seu e-mail"
        message="Nós enviamos instruções sobre uma nova senha para o seu e-mail"
        primaryLabel="Voltar para o login"
        onPrimary={() => navigate(routesConfig.LOGIN)}
      />
    </BrandedSplitLayout>
  );
};

export default ForgotPasswordLastStepBranded;
